export const mapSalesStatus = (salesStatus: string) => {
    switch (salesStatus) {
        case 'AVAILABLE':
            return 'available';
        case 'PREORDER_EMBARGO':
            return 'preorderEmbargoed';
        case 'COMING_SOON':
            return 'comingSoon';
        case 'PREORDER':
            return 'preorder';
        default:
            return null;
    }
};
